<div tabindex="0" (click)="!disabled && (this.focused = true)" (focus)="!disabled && (this.focused = true)">
  @if (!focused && value) {
    <nb-user [size]="size" [badgeStatus]="status" shape="round" [picture]="logo" [color]="'#333'" [name]="name"></nb-user>
  }
  @if (!focused && !value) {
    <span class="add-affordance" [class.disabled]="disabled">
      <nb-icon icon="plus-outline"></nb-icon>
      <label>{{ 'addmember' | translate }}</label>
    </span>
  }
  @if (focused) {
    <bst-list-adder (click)="$event.stopPropagation();" [autolist]="true" [formControl]="control" [single]="true" [size]="size" [status]="status" [target]="'member'"></bst-list-adder>
  }
</div>
